import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Save, Loader2, FileSearch } from "lucide-react";
import FloatingPDFViewer from "./FloatingPDFViewer";
import PinchZoomPdf from "./PinchZoomPdf";
import { renderPdfToPages } from "../utils/pdfjsLoader";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ===== Catálogo do Labor Bill ANTIGO (modelo do PDF enviado pelo usuário) =====
const LEFT_SECTIONS = [
  {
    title: "Insert Frame Windows Install",
    items: [
      { key: "insert_unit_120", description: "Unit Up To 120 UI", price: 120 },
      { key: "insert_unit_over_120", description: "Unit Over 120 UI", price: 150 },
      { key: "insert_casement_120", description: "Casement up to 120", price: 190 },
      { key: "insert_casement_over_120", description: "Casement over 120", price: 210 },
      { key: "insert_glider_120", description: "Glider Up To 120 UI", price: 190 },
      { key: "insert_glider_over_120", description: "Glider Over 120 UI", price: 210 },
    ],
  },
  {
    title: "Full Frame Windows Install",
    items: [
      { key: "full_unit_120", description: "Unit Up To 120 UI", price: 130 },
      { key: "full_unit_over_120", description: "Unit Over 120 UI", price: 165 },
    ],
  },
  {
    title: "Patio Door Install - Provia Door Install",
    items: [
      { key: "single_panel", description: "Single panel", price: 350 },
      { key: "panel_glider_2", description: "2 panel glider", price: 750 },
      { key: "dbl_hinge", description: "Dbl Hinge/Hinge w/ Fixed PNL", price: 850 },
      { key: "door_8ft", description: "8' Door", price: 1000 },
      { key: "per_lf_over_8", description: "Per LF over 8'", price: 100 },
      { key: "sidelite", description: "Sidelite", price: 120 },
      { key: "transom", description: "Transom", price: 120 },
      { key: "assemble_frame", description: "Assemble door frame", price: 75 },
      { key: "storm_door", description: "Storm door", price: 150 },
    ],
  },
  {
    title: "Replacement Items - Entire Window",
    items: [
      { key: "brickmould", description: "Brickmould", price: 20 },
      { key: "sill_nosing", description: "Sill Nosing", price: 10 },
      { key: "wood_sill", description: "Wood Sill", price: 25 },
      { key: "casing_interior", description: "Casing Interior", price: 25 },
      { key: "stool_interior", description: "Stool Interior", price: 15 },
      { key: "replace_stops", description: "Replace Stops or L Trim", price: 10 },
    ],
  },
  {
    title: "Lead Safe Work Place",
    items: [{ key: "lswp", description: "LSWP/Opening", price: 50 }],
  },
  {
    title: "Covid Setups",
    items: [{ key: "covid", description: "Covid/Opening", price: 10 }],
  },
];

const RIGHT_SECTIONS = [
  {
    title: "Opening Minor Modifications",
    items: [
      { key: "cutback_ext", description: "Cutback Exterior", price: 25 },
      { key: "cutback_int", description: "Cutback Interior", price: 25 },
      { key: "rr_vinyl", description: "R&R Vinyl Siding", price: 50 },
      { key: "add_buck", description: "Add Buck Frame", price: 50 },
    ],
  },
  {
    title: "Structural",
    items: [{ key: "knee_wall", description: "Knee Wall Per LF", price: 50 }],
  },
  {
    title: "Project Extras",
    items: [
      { key: "remove_burglar", description: "Remove Burglar Bars", price: 35 },
      { key: "trip_50", description: "Trip Charge 50", price: 50 },
      { key: "trip_75", description: "Trip Charge 75", price: 75 },
      { key: "trip_100", description: "Trip Charge 100", price: 100 },
      { key: "out_of_town", description: "Out of town/Over 150", price: 250 },
      { key: "third_floor", description: "3rd Floor Exterior Per side", price: 150 },
      { key: "second_floor", description: "2nd Floor Open Interior", price: 250 },
    ],
  },
  {
    title: "OTHERS — Must be Approved and include Photos",
    items: [
      { key: "min_job", description: "Minimum Job", price: 300 },
      { key: "min_daily", description: "Minimum Daily", price: 500 },
      { key: "blinds", description: "Blinds R&R/Storms", price: 10 },
      { key: "subfloor", description: "Sub floor repair", price: 100 },
      { key: "mull", description: "Mull windows together", price: 30 },
      { key: "rr_shutters", description: "R&R shutters", price: 20 },
    ],
  },
];

const ALL_ITEMS = [
  ...LEFT_SECTIONS.flatMap((s) => s.items),
  ...RIGHT_SECTIONS.flatMap((s) => s.items),
];

const normalize = (s) => (s || "").toString().toLowerCase().replace(/[^a-z0-9]/g, "");
const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(
    Number(n) || 0
  );

export default function OldBillComparisonModal({ open, onClose, bill, user }) {
  const [header, setHeader] = useState({});
  const [qtys, setQtys] = useState({});
  const [extraLabor, setExtraLabor] = useState([]);
  const [submittedBy, setSubmittedBy] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [newPdfUrl, setNewPdfUrl] = useState(null);
  const [newPdfPages, setNewPdfPages] = useState([]);
  const [pdfLoading, setPdfLoading] = useState(false);
  // PDF do trabalho (work order) — mesmo comportamento do editor de Labor Bill
  const [workPdfUrl, setWorkPdfUrl] = useState(null);
  const [workPdfTitle, setWorkPdfTitle] = useState("");
  const [showWorkPdf, setShowWorkPdf] = useState(false);
  const [workPdfLoading, setWorkPdfLoading] = useState(false);
  const [mobileTab, setMobileTab] = useState("old"); // 'old' | 'new' — só no mobile

  // Pré-preenche a partir do bill atual (best-effort por nome normalizado)
  const buildPrefill = (b) => {
    const billQtyByNorm = {};
    [...(b.items || []), ...(b.extra_items || [])].forEach((it) => {
      const q = Number(it.qty) || 0;
      if (q > 0) billQtyByNorm[normalize(it.description)] = q;
    });
    const q = {};
    ALL_ITEMS.forEach((it) => {
      const match = billQtyByNorm[normalize(it.description)];
      if (match) q[it.key] = match;
    });
    return {
      header: {
        install_date: b.install_date || "",
        job_name: b.job_name || "",
        pm_code: b.pm_code || b.pm_user || "",
        order_number: b.order_number || "",
        total_windows: b.total_windows ?? "",
        total_doors: b.total_doors ?? "",
      },
      qtys: q,
      submitted_by: b.pm_code || b.pm_user || "",
    };
  };

  // Carregar dados salvos (ou pré-preencher) + PDF do bill novo
  useEffect(() => {
    if (!open || !bill?.id) return;
    let revoked = null;
    // Reseta o PDF do trabalho ao (re)abrir/trocar de bill — evita puxar o PDF do bill anterior
    setWorkPdfUrl(null);
    setWorkPdfTitle("");
    setShowWorkPdf(false);
    const load = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${API}/labor-bills/${bill.id}/old-comparison`);
        if (data?.data && Object.keys(data.data).length) {
          setHeader(data.data.header || {});
          setQtys(data.data.qtys || {});
          setSubmittedBy(data.data.submitted_by || "");
          setExtraLabor(data.data.extra_labor || []);
        } else {
          const pf = buildPrefill(bill);
          setHeader(pf.header);
          setQtys(pf.qtys);
          setSubmittedBy(pf.submitted_by);
          setExtraLabor([]);
        }
      } catch (e) {
        const pf = buildPrefill(bill);
        setHeader(pf.header);
        setQtys(pf.qtys);
        setSubmittedBy(pf.submitted_by);
        setExtraLabor([]);
      }
      setLoading(false);
    };
    const loadPdf = async () => {
      setPdfLoading(true);
      setNewPdfUrl(null);
      setNewPdfPages([]);
      try {
        const isAdmin = user?.role === "admin";
        const pmUser = bill?.pm_user || "PM1";
        const url = isAdmin
          ? `${API}/admin/pm/${pmUser}/labor-bills/${bill.id}/pdf?t=${Date.now()}`
          : `${API}/labor-bills/${bill.id}/pdf?t=${Date.now()}`;
        const res = await axios.get(url);
        const bytes = window.atob(res.data.pdf_data);
        const arr = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
        const blobUrl = window.URL.createObjectURL(new Blob([arr], { type: "application/pdf" }));
        revoked = blobUrl;
        setNewPdfUrl(blobUrl);
        try {
          const pages = await renderPdfToPages(blobUrl, { renderScale: 1.6 });
          setNewPdfPages(pages);
        } catch (_) {
          setNewPdfPages([]);
        }
      } catch (e) {
        setNewPdfUrl(null);
      }
      setPdfLoading(false);
    };
    load();
    loadPdf();
    return () => {
      if (revoked) window.URL.revokeObjectURL(revoked);
    };
  }, [open, bill?.id]); // eslint-disable-line

  const extraLaborTotal = useMemo(
    () => extraLabor.reduce((s, r) => s + (Number(r.qty) || 0) * (Number(r.unit) || 0), 0),
    [extraLabor]
  );

  const grandTotal = useMemo(
    () => ALL_ITEMS.reduce((s, it) => s + (Number(qtys[it.key]) || 0) * it.price, 0) + extraLaborTotal,
    [qtys, extraLaborTotal]
  );

  const setQty = (key, val) => {
    const n = val === "" ? "" : Math.max(0, parseInt(val, 10) || 0);
    setQtys((prev) => ({ ...prev, [key]: n }));
  };

  const addExtra = () =>
    setExtraLabor((p) => [
      ...p,
      { id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, description: "", qty: "", unit: "" },
    ]);
  const updateExtra = (id, field, val) =>
    setExtraLabor((p) =>
      p.map((r) =>
        r.id === id
          ? { ...r, [field]: field === "description" ? val : val === "" ? "" : Math.max(0, parseFloat(val) || 0) }
          : r
      )
    );
  const removeExtra = (id) => setExtraLabor((p) => p.filter((r) => r.id !== id));

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/labor-bills/${bill.id}/old-comparison`, {
        data: { header, qtys, submitted_by: submittedBy, extra_labor: extraLabor },
      });
      toast.success("Comparação (bill antigo) salva!");
    } catch (e) {
      toast.error("Falha ao salvar comparação");
    }
    setSaving(false);
  };

  // Abre o PDF do trabalho (work order), mesma lógica do editor de Labor Bill
  const openWorkPdf = async () => {
    if (workPdfUrl) {
      setShowWorkPdf(true);
      return;
    }
    const jobId = bill?.schedule_job_id;
    if (!jobId) {
      toast.info("Este Labor Bill não tem PDF do trabalho vinculado.");
      return;
    }
    setWorkPdfLoading(true);
    try {
      const { data: jobs } = await axios.get(`${API}/schedules`);
      const job = (jobs || []).find((j) => j.id === jobId);
      if (job?.draft_pdf_url) {
        setWorkPdfUrl(`${API}/files/${job.draft_pdf_url}`);
        setWorkPdfTitle(`${job.customer_name || "Work Order"}${job.order_number ? " - " + job.order_number : ""}`);
        setShowWorkPdf(true);
      } else {
        toast.info("Sem PDF do trabalho para este Labor Bill.");
      }
    } catch (e) {
      toast.error("Falha ao carregar o PDF do trabalho.");
    }
    setWorkPdfLoading(false);
  };

  const renderTable = (sections, headerLabel) => (
    <table className="w-full border-collapse text-[11px]">
      <thead>
        {headerLabel && (
          <tr>
            <td colSpan={4} className="border border-gray-400 bg-gray-300 font-bold px-1 py-0.5 text-center">
              {headerLabel}
            </td>
          </tr>
        )}
        <tr className="bg-gray-200">
          <th className="border border-gray-400 px-1 py-0.5 text-left">Item Description</th>
          <th className="border border-gray-400 px-1 py-0.5 w-10">QTY</th>
          <th className="border border-gray-400 px-1 py-0.5 w-12">$$</th>
          <th className="border border-gray-400 px-1 py-0.5 w-16">Total</th>
        </tr>
      </thead>
      <tbody>
        {sections.map((sec) => (
          <React.Fragment key={sec.title}>
            <tr>
              <td colSpan={4} className="border border-gray-400 bg-gray-100 font-semibold px-1 py-0.5">
                {sec.title}
              </td>
            </tr>
            {sec.items.map((it) => {
              const q = Number(qtys[it.key]) || 0;
              const total = q * it.price;
              return (
                <tr key={it.key}>
                  <td className="border border-gray-300 px-1 py-0.5">{it.description}</td>
                  <td className="border border-gray-300 px-0.5 py-0.5">
                    <input
                      type="number"
                      min="0"
                      value={qtys[it.key] === undefined ? "" : qtys[it.key]}
                      onChange={(e) => setQty(it.key, e.target.value)}
                      data-testid={`old-qty-${it.key}`}
                      className="w-12 sm:w-9 text-center border border-gray-200 rounded px-0.5 py-1 sm:py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-400"
                    />
                  </td>
                  <td className="border border-gray-300 px-1 py-0.5 text-right text-gray-500">${it.price}</td>
                  <td className="border border-gray-300 px-1 py-0.5 text-right font-medium">
                    {q > 0 ? `$ ${total.toLocaleString("en-US")}` : ""}
                  </td>
                </tr>
              );
            })}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );

  // Extra Labor: write-in editável (descrição + qtd + valor unitário → total somado)
  const renderExtraLabor = () => (
    <table className="w-full border-collapse text-[11px] table-fixed">
      <colgroup>
        <col />
        <col style={{ width: "46px" }} />
        <col style={{ width: "62px" }} />
        <col style={{ width: "78px" }} />
      </colgroup>
      <tbody>
        <tr>
          <td colSpan={4} className="border border-gray-400 bg-gray-100 font-semibold px-1 py-0.5">
            Extra Labor
          </td>
        </tr>
        {extraLabor.map((r) => {
          const total = (Number(r.qty) || 0) * (Number(r.unit) || 0);
          return (
            <tr key={r.id}>
              <td className="border border-gray-300 px-0.5 py-0.5">
                <input
                  value={r.description}
                  onChange={(e) => updateExtra(r.id, "description", e.target.value)}
                  placeholder="Descrição do extra labor"
                  data-testid={`extra-desc-${r.id}`}
                  className="w-full border border-gray-200 rounded px-1 py-1 sm:py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-400"
                />
              </td>
              <td className="border border-gray-300 px-0.5 py-0.5">
                <input
                  type="number"
                  min="0"
                  value={r.qty}
                  onChange={(e) => updateExtra(r.id, "qty", e.target.value)}
                  data-testid={`extra-qty-${r.id}`}
                  className="w-full text-center border border-gray-200 rounded px-0.5 py-1 sm:py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-400"
                />
              </td>
              <td className="border border-gray-300 px-0.5 py-0.5">
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={r.unit}
                  onChange={(e) => updateExtra(r.id, "unit", e.target.value)}
                  placeholder="$"
                  data-testid={`extra-unit-${r.id}`}
                  className="w-full text-right border border-gray-200 rounded px-1 py-1 sm:py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-400"
                />
              </td>
              <td className="border border-gray-300 px-1 py-0.5 text-right font-medium whitespace-nowrap">
                {total > 0 ? `$ ${total.toLocaleString("en-US")}` : ""}
                <button
                  onClick={() => removeExtra(r.id)}
                  data-testid={`extra-remove-${r.id}`}
                  title="Remover"
                  className="ml-1 text-red-400 hover:text-red-600 align-middle font-bold"
                >
                  ×
                </button>
              </td>
            </tr>
          );
        })}
        <tr>
          <td colSpan={4} className="border border-gray-300 px-1 py-1">
            <button
              onClick={addExtra}
              data-testid="extra-add-btn"
              className="text-blue-600 hover:text-blue-800 text-[11px] font-semibold"
            >
              + Adicionar Extra Labor
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  );

  const HeaderInput = ({ field, className = "" }) => (
    <input
      value={header[field] ?? ""}
      onChange={(e) => setHeader((prev) => ({ ...prev, [field]: e.target.value }))}
      data-testid={`old-header-${field}`}
      className={`border border-gray-400 rounded px-1 py-0.5 text-[11px] focus:outline-none focus:ring-1 focus:ring-blue-400 ${className}`}
    />
  );

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="max-w-[100vw] w-screen h-[100dvh] rounded-none sm:max-w-[97vw] sm:w-[97vw] sm:h-[93vh] sm:rounded-lg p-0 flex flex-col"
        data-testid="old-bill-compare-modal"
      >
        <DialogHeader className="px-4 py-3 border-b shrink-0">
          <DialogTitle className="flex flex-col gap-2 pr-8 sm:flex-row sm:items-center sm:justify-between sm:pr-10">
            <span className="text-sm sm:text-base truncate">
              🆚 Comparar Labor Bill — <span className="text-blue-700">{bill?.job_name || ""}</span>
            </span>
            <div className="flex items-center gap-2 shrink-0">
              <Button
                size="sm"
                variant="outline"
                onClick={openWorkPdf}
                disabled={workPdfLoading}
                data-testid="old-compare-work-pdf-btn"
                className="text-blue-600 border-blue-300 hover:bg-blue-50 flex-1 sm:flex-none"
                title="Abrir o PDF do trabalho"
              >
                {workPdfLoading ? (
                  <Loader2 className="h-4 w-4 mr-1 animate-spin" />
                ) : (
                  <FileSearch className="h-4 w-4 mr-1" />
                )}
                PDF
              </Button>
              <Button
                size="sm"
                onClick={handleSave}
                disabled={saving || loading}
                data-testid="old-compare-save-btn"
                className="bg-green-600 hover:bg-green-700 text-white flex-1 sm:flex-none"
              >
                {saving ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Save className="h-4 w-4 mr-1" />}
                Salvar comparação
              </Button>
            </div>
          </DialogTitle>
        </DialogHeader>

        {/* Alternador mobile: Antigo x Novo (no desktop os dois aparecem lado a lado) */}
        <div className="lg:hidden flex border-b shrink-0">
          <button
            onClick={() => setMobileTab("old")}
            data-testid="compare-mobile-tab-old"
            className={`flex-1 py-2.5 text-sm font-semibold ${mobileTab === "old" ? "bg-amber-50 text-amber-800 border-b-2 border-amber-500" : "text-gray-500"}`}
          >
            📝 Antigo (editável)
          </button>
          <button
            onClick={() => setMobileTab("new")}
            data-testid="compare-mobile-tab-new"
            className={`flex-1 py-2.5 text-sm font-semibold ${mobileTab === "new" ? "bg-blue-50 text-blue-800 border-b-2 border-blue-500" : "text-gray-500"}`}
          >
            📄 Novo (PDF)
          </button>
        </div>

        <div className="flex-1 min-h-0 flex flex-col lg:grid lg:grid-cols-2 gap-3 p-3 overflow-hidden">
          {/* LADO ESQUERDO — Bill ANTIGO editável */}
          <div className={`${mobileTab === "old" ? "flex" : "hidden"} flex-1 lg:flex flex-col min-h-0 border rounded-lg overflow-hidden`}>
            <div className="bg-amber-50 border-b border-amber-200 px-3 py-1.5 text-sm font-semibold text-amber-800 shrink-0">
              📝 Bill Antigo (editável)
            </div>
            <div className="flex-1 overflow-auto p-3 bg-white" data-testid="old-bill-form">
              {loading ? (
                <div className="flex items-center justify-center h-40 text-gray-400">
                  <Loader2 className="h-6 w-6 animate-spin mr-2" /> Carregando...
                </div>
              ) : (
                <div className="text-gray-900">
                  <div className="text-center font-bold text-sm mb-2">PM Home Remodeling - Labor Billing</div>
                  {/* Cabeçalho */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-2 text-[11px]">
                    <div className="flex flex-col gap-1">
                      <div className="flex items-center gap-1">
                        <span className="w-20 font-semibold">Install Date</span>
                        <HeaderInput field="install_date" className="flex-1" />
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="w-20 font-semibold">PM</span>
                        <HeaderInput field="pm_code" className="flex-1 font-bold text-center" />
                      </div>
                    </div>
                    <div className="flex flex-col gap-1">
                      <div className="flex items-center gap-1">
                        <span className="w-24 font-semibold">Job Name</span>
                        <HeaderInput field="job_name" className="flex-1" />
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="w-24 font-semibold">Order #</span>
                        <HeaderInput field="order_number" className="flex-1" />
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="w-24 font-semibold">Total Windows</span>
                        <HeaderInput field="total_windows" className="w-16" />
                        <span className="font-semibold ml-1">Doors</span>
                        <HeaderInput field="total_doors" className="w-16" />
                      </div>
                    </div>
                  </div>
                  <div className="text-[9px] italic text-gray-500 mb-2 leading-tight">
                    Unless otherwise specified, charges are per opening and include installation of drip cap, seal pan,
                    interior stop trim, foam, sealant, capping, or L-trim finish.
                  </div>
                  {/* Duas colunas do formulário */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 items-start">
                    <div>
                      {renderTable(LEFT_SECTIONS, null)}
                      {renderExtraLabor()}
                    </div>
                    <div>{renderTable(RIGHT_SECTIONS, null)}</div>
                  </div>
                  {/* Rodapé */}
                  <div className="flex items-center justify-between mt-3 gap-2 flex-wrap">
                    <div className="flex items-center gap-1 text-[11px]">
                      <span className="font-semibold">Submitted by</span>
                      <input
                        value={submittedBy}
                        onChange={(e) => setSubmittedBy(e.target.value)}
                        data-testid="old-submitted-by"
                        className="border border-gray-400 rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-400"
                      />
                    </div>
                    <div className="bg-gray-200 border border-gray-400 px-3 py-1 font-bold text-sm" data-testid="old-grand-total">
                      TOTAL {money(grandTotal)}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* LADO DIREITO — Bill NOVO (PDF) */}
          <div className={`${mobileTab === "new" ? "flex" : "hidden"} flex-1 lg:flex flex-col min-h-0 border rounded-lg overflow-hidden`}>
            <div className="bg-blue-50 border-b border-blue-200 px-3 py-1.5 text-sm font-semibold text-blue-800 shrink-0">
              📄 Bill Novo / Atual (somente leitura)
            </div>
            <div className="flex-1 min-h-0 bg-gray-100 overflow-hidden">
              {pdfLoading ? (
                <div className="flex items-center justify-center h-full text-gray-400">
                  <Loader2 className="h-6 w-6 animate-spin mr-2" /> Carregando PDF...
                </div>
              ) : newPdfUrl ? (
                <>
                  {/* Desktop: iframe nativo (inalterado) */}
                  <iframe src={newPdfUrl} title="new-bill-pdf" className="hidden lg:block w-full h-full" data-testid="new-bill-pdf-frame" />
                  {/* Mobile: páginas via pdf.js com pinça/zoom (funciona no iPhone) */}
                  <div className="lg:hidden w-full h-full" data-testid="new-bill-pdf-mobile">
                    {newPdfPages.length ? (
                      <PinchZoomPdf pages={newPdfPages} />
                    ) : (
                      <div className="flex items-center justify-center h-40 text-gray-400 text-sm">
                        <Loader2 className="h-5 w-5 animate-spin mr-2" /> Renderizando PDF...
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="flex items-center justify-center h-full text-gray-400 text-sm">
                  PDF do bill novo indisponível
                </div>
              )}
            </div>
          </div>
        </div>

        {showWorkPdf && workPdfUrl && (
          <FloatingPDFViewer
            pdfUrl={workPdfUrl}
            title={workPdfTitle || "Work Order PDF"}
            onMinimize={() => setShowWorkPdf(false)}
            onClose={() => setShowWorkPdf(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
